export default {
  ID: '',
  ALL: [],
  SHOW: true,
  LAST_PATH: '/'
}
